import createAPI from '../axios'

// 选修管理相关API
const electiveManage = {
	classSetting: {
	    list: config => createAPI('/classSetting/list', 'post', config),
        initOption: config => createAPI('/classSetting/initOption', 'post', config),
        deptOption: config => createAPI('/classSetting/deptOption', 'post', config),
        majorOption: config => createAPI('/classSetting/majorOption', 'post', config),
        classOption: config => createAPI('/classSetting/classOption', 'post', config),
        queryElectiveTime: config => createAPI('/classSetting/queryElectiveTime', 'post', config),
		saveElectiveTime: config => createAPI('/classSetting/saveElectiveTime', 'post', config),
        initCredit: config => createAPI('/classSetting/initCredit', 'post', config),
        queryCredit: config => createAPI('/classSetting/queryCredit', 'post', config),
        saveCreditSet: config => createAPI('/classSetting/saveCreditSet', 'post', config),
        getWeeknum: config => createAPI('/classSetting/getWeeknum', 'post', config),
        courseOption: config => createAPI('/classSetting/courseOption', 'post', config),
        classTimeOption: config => createAPI('/classSetting/classTimeOption', 'post', config),
        queryTeacher: config => createAPI('/classSetting/queryTeacher', 'post', config),
        querySite: config => createAPI('/classSetting/querySite', 'post', config),
        saveElective: config => createAPI('/classSetting/saveElective', 'post', config),
        delElective: config => createAPI('/classSetting/delElective', 'post', config),
        timeslotOption: config => createAPI('/classSetting/timeslotOption', 'post', config),
        relatedCourseOption: config => createAPI('/classSetting/relatedCourseOption', 'post', config),
        courseTypeOption: config => createAPI('/classSetting/courseTypeOption', 'post', config),
	},
    studentSelection: {
        list: config => createAPI('/studentSelection/list', 'post', config),
        initOption: config => createAPI('/studentSelection/initOption', 'post', config),
    	checkSelectTime: config => createAPI('/studentSelection/checkSelectTime', 'post', config),
        studentSelection: config => createAPI('/studentSelection/studentSelection', 'post', config),
        queryStuSelection: config => createAPI('/studentSelection/queryStuSelection', 'post', config),
        delSelection: config => createAPI('/studentSelection/delSelection', 'post', config),
    },
    electiveManage: {
        list: config => createAPI('/electiveManage/list', 'post', config),
        initOption: config => createAPI('/electiveManage/initOption', 'post', config),
        queryElectiveClassStu: config => createAPI('/electiveManage/queryElectiveClassStu', 'post', config),
        queryStudent: config => createAPI('/electiveManage/queryStudent', 'post', config),
        saveElectiveStu: config => createAPI('/electiveManage/saveElectiveStu', 'post', config),
        queryChangeClassList: config => createAPI('/electiveManage/queryChangeClassList', 'post', config),
        changeElectiveStu: config => createAPI('/electiveManage/changeElectiveStu', 'post', config),
        delElectiveStu: config => createAPI('/electiveManage/delElectiveStu', 'post', config),
        exportCourse: config => createAPI('/electiveManage/exportCourse', 'post', config),
        exportStudent: config => createAPI('/electiveManage/exportStudent', 'post', config),
        queryInsufficientCredit: config => createAPI('/electiveManage/queryInsufficientCredit', 'post', config),
        queryStuCredit: config => createAPI('/electiveManage/queryStuCredit', 'post', config),
        exportCredit: config => createAPI('/electiveManage/exportCredit', 'post', config),
        importElectiveScore: config => createAPI('/electiveManage/importElectiveScore', 'post', config),
        queryNoChooseXXK: config => createAPI('/electiveManage/queryNoChooseXXK', 'post', config),
        exportNochoose: config => createAPI('/electiveManage/exportNochoose', 'post', config),
    },
    electiveInfo: {
        list: config => createAPI('/electiveInfo/list', 'post', config),
        initOption: config => createAPI('/electiveInfo/initOption', 'post', config),
        deptOption: config => createAPI('/electiveInfo/deptOption', 'post', config),
        majorOption: config => createAPI('/electiveInfo/majorOption', 'post', config),
        classOption: config => createAPI('/electiveInfo/classOption', 'post', config),
        exportStuSelection: config => createAPI('/electiveInfo/exportStuSelection', 'post', config),
    }
};

export default electiveManage;



// WEBPACK FOOTER //
// ./src/api/modules/electiveManage.js